module.exports = __webpack_public_path__ + "img/house-person-return.84848420.svg";